<script setup lang="ts">
import ArrowDownIcon from '@/assets/icons/ArrowDownIcon.vue';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import LoaderIcon from '@/assets/icons/LoaderIcon.vue';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    isSubmitting: boolean;
    mobileExpanded?: boolean;
    submitLabel: string;
  }>(),
  {
    disabled: false,
    mobileExpanded: false,
  },
);

const emit = defineEmits<{
  collapse: [];
  submit: [];
}>();
</script>

<template>
  <div class="ml-auto flex items-center gap-sm" :class="props.mobileExpanded && 'ml-0 w-full justify-between'">
    <button
      v-if="props.mobileExpanded"
      type="button"
      class="flex size-button shrink-0 items-center justify-center rounded-button bg-surface-secondary text-primary state-effects"
      :aria-label="$t('general.close')"
      :disabled="props.isSubmitting"
      @click="emit('collapse')"
    >
      <CloseIcon class="size-icon-md" />
    </button>

    <div class="ml-auto flex items-center gap-sm">
      <slot></slot>
      <button
        type="button"
        class="flex size-button items-center justify-center rounded-button bg-tint text-on-tint outline-inner transition duration-300 hover:bg-tint-hover active:bg-tint-active disabled:pointer-events-none disabled:opacity-40"
        :disabled="props.isSubmitting || props.disabled"
        :aria-label="props.submitLabel"
        :title="props.submitLabel"
        @click="emit('submit')"
      >
        <LoaderIcon v-if="props.isSubmitting" class="size-icon-md animate-spin" />
        <slot v-else name="submit-icon" :mobile-expanded="props.mobileExpanded">
          <ArrowDownIcon class="size-icon-md" :class="props.mobileExpanded && 'rotate-180'" />
        </slot>
      </button>
    </div>
  </div>
</template>
